import React from 'react';

export default useHierarchicalSelector;
export function useHierarchicalSelector() {
  const [state, setState] = React.useState({ search: '' });
  
  return {
    handleSearch: event => setState({...state, search: (event.target.value || '').toLowerCase().trim() }),
    search: state.search
  }
}